export const DATABASE_SETUP_TYPE = {
  heroku: 'heroku',
  custom: 'custom',
  helpRequired: 'help-required',
} as const;

export const DATABASE_TYPES = {
  postgres: 'postgres',
  mySql: 'mysql',
  snowflake: 'snowflake',
  bigQuery: 'bigquery',
  redshift: 'redshift',
  panoply: 'panoply',
  sqlServer: 'sqlserver',
  mariaDb: 'mariadb',
  azureSql: 'azuresql',
} as const;

type DatabaseTypeKeys = keyof typeof DATABASE_TYPES;
export type DatabaseTypeValues = typeof DATABASE_TYPES[DatabaseTypeKeys];

export const DATABASE_TYPES_SETUP_PAGES: Record<DatabaseTypeValues, string> = {
  [DATABASE_TYPES.postgres]: '/setup/postgres',
  [DATABASE_TYPES.mySql]: '/setup/mysql',
  [DATABASE_TYPES.snowflake]: '/setup/snowflake',
  [DATABASE_TYPES.bigQuery]: '/setup/bigquery',
  [DATABASE_TYPES.redshift]: '/setup/redshift',
  [DATABASE_TYPES.panoply]: '/setup/bigquery',
  [DATABASE_TYPES.sqlServer]: '/setup/sqlserver',
  [DATABASE_TYPES.mariaDb]: '/setup/mysql',
  [DATABASE_TYPES.azureSql]: '/setup/sqlserver',
};

export const HOSTING_PROVIDERS = {
  amazonAws: 'amazon-aws',
  googleCloud: 'google-cloud',
  microsoftAzure: 'microsoft-azure',
  localhost: 'localhost',
  heroku: 'heroku',
  digitalOcean: 'digital-ocean',
  snowflake: 'snowflake',
  supabase: 'supabase',
  hostinger: 'hostinger',
  lindoe: 'lindoe',
  unknown: 'unknown',
} as const;

type HostingProviderOptionType = {
  iconName?: string;
  label: string;
  value: string;
};

export const hostingProviderOptions: HostingProviderOptionType[] = [
  {
    iconName: 'amazon-aws',
    value: HOSTING_PROVIDERS.amazonAws,
    label: 'Amazon AWS',
  },
  {
    iconName: 'google-cloud',
    value: HOSTING_PROVIDERS.googleCloud,
    label: 'Google Cloud',
  },
  {
    iconName: 'microsoft-azure',
    value: HOSTING_PROVIDERS.microsoftAzure,
    label: 'Microsoft azure',
  },
  {
    iconName: 'sql',
    value: HOSTING_PROVIDERS.localhost,
    label: 'Localhost (on my computer)',
  },
  {
    iconName: 'heroku',
    value: HOSTING_PROVIDERS.heroku,
    label: 'Heroku',
  },
  {
    iconName: 'digital-ocean',
    value: HOSTING_PROVIDERS.digitalOcean,
    label: 'Digital Ocean',
  },
  {
    iconName: 'snowflake',
    value: HOSTING_PROVIDERS.snowflake,
    label: 'Snowflake',
  },
  {
    iconName: 'supabase',
    value: HOSTING_PROVIDERS.supabase,
    label: 'Supabase',
  },
  {
    iconName: 'hostinger',
    value: HOSTING_PROVIDERS.hostinger,
    label: 'Hostinger',
  },
  {
    iconName: 'lindoe',
    value: HOSTING_PROVIDERS.lindoe,
    label: 'Lindoe',
  },
  {
    iconName: 'question',
    value: HOSTING_PROVIDERS.unknown,
    label: 'Not sure where it is hosted',
  },
];

export const isHostingProviderOtherSelected = (value: Maybe<string>) =>
  Boolean(
    value &&
      !hostingProviderOptions.map((option) => option.value).includes(value),
  );
